// extracted by mini-css-extract-plugin
export var logo = "main-nav-module--logo--T8aNd";
export var mainMenu = "main-nav-module--main-menu--7DHCo";
export var mainNav = "main-nav-module--main-nav--U9Iik";
export var menuBtn = "main-nav-module--menu-btn--fjBA+";
export var rightMenu = "main-nav-module--right-menu--FylP7";
export var root = "main-nav-module--root--Eu5A8";